import BaseService from "@services/BaseService";

export default class StatisticsService extends BaseService {
  entity = "statistics";
}

export const ledgerService = new StatisticsService();
